module.exports = __webpack_public_path__ + "img/shield-lock.6e7f6355.svg";